import { useCallback } from 'react';

import { useCatalogContext } from '../../state/Catalog';
import type { CurationCardProps, UseCurationCardGridArgs } from './CurationCard.types';
import { useCatalogLoggingContext } from '../../Catalog.logging';

export const useCurationCardGrid = ({ onClick, telemetryPageValue }: UseCurationCardGridArgs) => {
  const { goToCurationDetails } = useCatalogContext();
  const { trackCurationClickAction } = useCatalogLoggingContext();

  const onCurationClick = useCallback<NonNullable<CurationCardProps['onClick']>>(
    (curation, index, e) => {
      onClick?.(curation, index, e);
      trackCurationClickAction({ curation, curationPosition: index + 1, page: telemetryPageValue });
      goToCurationDetails(curation.publicUrlPath);
    },
    [trackCurationClickAction, goToCurationDetails, onClick, telemetryPageValue],
  );

  return { onCurationClick } as const;
};
